import { Suspense } from 'react';
import Box from '@mui/material/Box';
import { lazyWithReload } from 'utils/lazyWithReload';
import { useReducedMotion } from 'utils/motion';

// Lazy so @remotion/player only loads when the success screen renders.
const CvSuccessPlayer = lazyWithReload(
  () => import('./CvSuccessPlayer'),
  'CvSuccessPlayer'
);

/**
 * The CV-submit success animation as shown in the app: the Remotion composition played
 * once via @remotion/player (or its final frame as a still under reduced motion).
 * Square, rounded, capped width; the blue fallback matches the video's first frame so
 * there's no flash while the player chunk loads.
 */
export const CvSuccessAnimation = () => {
  const reduced = useReducedMotion();

  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: 280,
        aspectRatio: '1 / 1',
        mx: 'auto'
      }}
    >
      <Suspense fallback={null}>
        <CvSuccessPlayer reduced={reduced} />
      </Suspense>
    </Box>
  );
};
